import { useQuery } from "react-query";

import { useApi } from "../../providers/ApiProvider";
import { APQueryOptions, useAPQuery } from "../../providers/APQueryProvider";
import { Faq } from "../../types/Faq";

export type FaqsFilter = {
  appLocationId: string;
  quoteId?: string;
};

export const getFaqs = (filter: FaqsFilter, options: APQueryOptions = {}) => {
  const { fetchWithAuth } = useApi();
  const { isQueryEnabled } = useAPQuery();

  return useQuery({
    queryKey: ["faqs", filter.appLocationId],
    queryFn: (): Promise<Faq[]> => {
      return fetchWithAuth<Faq[]>("getFaqs", filter.appLocationId, {
        queryParams: {
          quoteId: filter.quoteId,
        },
      });
    },
    enabled: isQueryEnabled(options),
  });
};
